import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../hoc/formikComponents/FormikControl.js'
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance'
import { useQueryClient } from 'react-query'
import axios from 'axios';
import { APIURL } from '../../hoc/AxiosSetting/axios';
import { useParams } from 'react-router';
import { useHistory } from "react-router-dom";

function OtherCertificateStatus() {
    const { id } = useParams()
    const history = useHistory();
    const [initialValues, setInitialValues] = useState({

        id: "",
        _id: "",
        orgName: "",
        scope: "",
        address: "",
        certificateno: "",
        standard: "",
        typeOfCertification: "",
        initialcertdate: new Date(),
        dateofissue: new Date(),
        expirydate: new Date(),
        status: "",
        certstatusvalue: "",
        annenxure: "",
        createdBy: localStorage.getItem("userCode")

    })
    const certstatusOptions = [
        { key: 'Select', value: '-' },
        { key: 'Certification', value: 'Certification' },
        { key: 'Surveillance1', value: 'Surveillance1' },
        { key: 'Surveillance2', value: 'Surveillance2' },
        { key: 'Recertification', value: 'Recertification' }
    ]
    const statusOptions = [
        { key: 'Select', value: '-' },
        { key: 'Active', value: 'Active' },
        { key: 'Inactive', value: 'Inactive' },

    ]
    const mutation = useMutation((params) => Fetcher('post', '/api/othercertstatus/post/data', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                console.log("line no 50 post", data.data.response)
                ToastInstance('Success', 'Certficate status Data Added')
                history.push("/" + localStorage.getItem("role") + '/viewcertificationstatus/' + data.data.response._id);

            } else {
                var msg = 'Status - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Status' + error)
        }
    })

    const mutationEdit = useMutation((params) => Fetcher('patch', '/api/othercertstatus/patch/othercertdetails', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'data Updated')
                history.push("/" + localStorage.getItem("role") + '/viewcertificationstatus/' + id);
            } else {
                var msg = 'RFQ - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.error('Got error from backend', error)
            ToastInstance('Error', 'RFQ' + error)
        }
    })
    const getUrl = () => {
        const api = APIURL + '/api/othercertstatus/get/othercertificatedetailsview/' + id
        axios.get(api)
            .then(certData => {
                var tempData = certData.data.response;
                // tempData.certifId = certData.data.response._id;
                tempData.dateofissue = Date.parse(tempData.dateofissue);
                tempData.initialcertdate = Date.parse(tempData.initialcertdate);
                tempData.expirydate = Date.parse(tempData.expirydate);
                console.log("certData 79", tempData)
                setInitialValues(tempData)
            })
            .catch(err => {
                console.log(err)
            })
    }
    // const { data: OrgList, isLoading: orgLoading } = useQuery(
    //     'listorg',
    //     (userid) => Fetcher('get', '/api/certificatedetails/get/listcertificatedetailsdropdownuserwise/' + localStorage.getItem("userCode") + "/" + localStorage.getItem("role"), {}))

    const { data: CertList, isLoading: certLoading } = useQuery(
        'listCert',
        () => Fetcher('get', '/api/typeofcertifications/get/typeofcertkeyvalue', {}))

    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("values 89", values)
        if (values._id === "") {
            mutation.mutate(values)
        } else {
            mutationEdit.mutate(values)
        }
    }

    // useEffect(() => {
    //     if (initialValues._id === "") {
    //         var tempData = clauseData.data.response
    //         setInitialValues(tempData)

    //     }
    // }, [id && !isLoading && initialValues._id === ""])

    useEffect(() => {
        if (id !== undefined) {
            getUrl()
        }

    }, [id !== undefined])


    if (certLoading) return <h1>Loading</h1>
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                //validationSchema={validationSchema}
                onSubmit={onSubmit}

            >{
                    formik =>
                        <Form>
                            <div className="content-wrapper">
                                <section className="content">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="card-body">
                                                    <div className="formOuterDiv">

                                                        <div className="form1RowDiv">

                                                            <FormikControl control='input' type="text" label='Organization Name' name='orgName' />

                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl className="form-control" control='textarea' label="Scope" name='scope' />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl className="form-control" control='textarea' label="Company Address" name='address' />
                                                        </div>
                                                        <div className="form2RowDiv">

                                                            <FormikControl className="form-control" control='textarea' label="Certificate No" name='certificateno' />
                                                            <FormikControl control='select' label='Type of Certification *' options={CertList.data.response} name='typeOfCertification' />
                                                        </div>
                                                        <div className="form2RowDiv">

                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Original Registered Date' name='dateofissue' />
                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Current Issue Date' name='initialcertdate' />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Expiry Date' name='expirydate' />

                                                            <FormikControl className="form-control" control='select' label="Certfication Status" name='status' options={statusOptions} />


                                                        </div>
                                                        <div className='form2RowDiv'>
                                                            <FormikControl control='select' options={certstatusOptions} name='certstatusvalue' label="Audit Type" />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl className="form-control" control='textarea' label="Annenxure" name='annenxure' style={{height:"200px"}}/>
                                                        </div>
                                                         {/* <div className="form1RowDiv">
                                                        <label>Annenxure</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Annenxure' name='annenxure' data={initialValues.annenxure} />
                                                            </div>
                                                        </div> */}
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <button className="btn btn-primary float-right" type="submit" >Submit</button>
                                    </div>

                                </div>
                            </div>
                        </Form>
                }
            </Formik>
        </div>
    )
}

export default OtherCertificateStatus
